// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { Target, ITarget } from "./Target.gen";
import { MediaRequestStatuses } from "./Shared.Models.Api.V1.MediaRequestStatuses.gen";
import { FacilityEventType } from "./Shared.FacilityEventType.gen";

export interface IFacilityEvent {
	target: ITarget | undefined;

	clipRequestId: string | undefined;

	clipStatus: MediaRequestStatuses | undefined;

	hasClipVideo: boolean;

	id: string | undefined;

	facilityId: string | undefined;

	deviceId: string | undefined;

	externalTargetId: string | undefined;

	detectionZoneId: string | undefined;

	screenLineId: string | undefined;

	laneLineId: string | undefined;

	dateCreated: string | undefined;

	eventType: FacilityEventType;

	eventValue: number;

	eventValue2: number | undefined;

	attachmentUrl: string | undefined;

	clipAccessToken: string | undefined;

	reviewedAt: string | undefined;

	reviewedByUserId: string | undefined;

	reviewNotes: string | undefined;

	isValidAlert: boolean | undefined;

	$type?: string | undefined;
}
export class FacilityEvent {
	constructor(data?: IFacilityEvent) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.target) { this.target = new Target(data.target); }
		if (data.dateCreated) { this.dateCreated = new Date(data.dateCreated); }
		if (data.reviewedAt) { this.reviewedAt = new Date(data.reviewedAt); }
	}

	target: Target | undefined;

	clipRequestId: string | undefined;

	clipStatus: MediaRequestStatuses | undefined;

	hasClipVideo: boolean = false;

	id: string | undefined;

	facilityId: string | undefined;

	deviceId: string | undefined;

	externalTargetId: string | undefined;

	detectionZoneId: string | undefined;

	screenLineId: string | undefined;

	laneLineId: string | undefined;

	dateCreated: Date | undefined = new Date();

	eventType: FacilityEventType = 0;

	eventValue: number = 0;

	eventValue2: number | undefined;

	attachmentUrl: string | undefined;

	clipAccessToken: string | undefined;

	reviewedAt: Date | undefined;

	reviewedByUserId: string | undefined;

	reviewNotes: string | undefined;

	isValidAlert: boolean | undefined;

	static $type: string = "CoreApi.Models.FacilityEvent, ";
	$type?: string | undefined = FacilityEvent.$type;
}

